import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";

export default function Terms() {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Navbar />

      <main className="container mx-auto flex-1 px-4 py-8 md:py-12 max-w-3xl">
        <h1 className="text-3xl md:text-4xl font-bold text-foreground mb-6">
          Terms of Service
        </h1>

        <div className="space-y-8 text-foreground leading-relaxed">
          <section>
            <p className="text-sm text-muted-foreground">
              Last updated: June 2026.
            </p>
            <p className="mt-4">
              By creating an account or requesting to join MAS Matrimonial, you agree
              to these terms. If you do not agree, please do not use the service.
            </p>
          </section>

          <section>
            <h2 className="text-xl md:text-2xl font-semibold mb-3">Eligibility</h2>
            <ul className="list-disc pl-6 space-y-1">
              <li>You must be at least 18 years old.</li>
              <li>You must have a sincere intention to pursue marriage.</li>
              <li>You agree that introductions are mediated by a matchmaker, not by free browsing.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl md:text-2xl font-semibold mb-3">Code of conduct</h2>
            <p>While using the service you agree to:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>Communicate respectfully with matchmakers, candidates, and staff.</li>
              <li>Not harass, threaten, or demean any other user.</li>
              <li>Not impersonate another person or misrepresent your identity, age, or status.</li>
              <li>Not misuse contact information revealed through a match for purposes outside of matrimonial introduction (e.g. spam, sales, recruiting, harassment).</li>
              <li>Not use the platform for any non-matrimonial purpose.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl md:text-2xl font-semibold mb-3">Matchmaker mediation</h2>
            <p>
              All introductions on MAS Matrimonial are made by a matchmaker.
              Candidates do not browse each other&rsquo;s profiles. A profile becomes
              visible to another candidate only after both have accepted a match
              suggested by the matchmaker.
            </p>
          </section>

          <section>
            <h2 className="text-xl md:text-2xl font-semibold mb-3">Suspension and removal</h2>
            <p>
              We may suspend or remove an account for any violation of these terms,
              including but not limited to harassment, dishonesty, or misuse of
              contact information. If you believe your account was suspended in
              error, you may appeal by emailing the founder (see Contact below).
            </p>
          </section>

          <section>
            <h2 className="text-xl md:text-2xl font-semibold mb-3">Service changes</h2>
            <p>
              Features and terms may change as the platform evolves. We will notify
              users of any material changes by email.
            </p>
          </section>

          <section>
            <h2 className="text-xl md:text-2xl font-semibold mb-3">No warranty</h2>
            <p>
              The service is provided <strong>as-is</strong>, without any warranty of fitness, availability, or correctness. Your use
              of the service is at your own risk.
            </p>
          </section>

          <section>
            <h2 className="text-xl md:text-2xl font-semibold mb-3">Governing law</h2>
            <p>
              These terms are governed by the laws of{" "}
              <span className="font-mono bg-muted px-1.5 py-0.5 rounded text-sm">
                Texas
              </span>
              , without regard to conflict-of-law principles.
            </p>
          </section>

          <section>
            <h2 className="text-xl md:text-2xl font-semibold mb-3">Contact</h2>
            <p>
              For questions about these terms or to appeal account actions, email
              the founder at{" "}
              <span className="font-mono bg-muted px-1.5 py-0.5 rounded text-sm">
                admin@masmatrimonial.com
              </span>
              .
            </p>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
}
